import { COOKIE_NAME } from '../settings.js'
import Cookies from 'js-cookie'

/**
 * Set cookie consent
 * @param {Object<string, boolean>} settings Cookie list
 */
export function setCookie (settings) {
  const cookieValue = []

  Object.keys(settings).forEach(cookie => {
    if (settings[cookie]) {
      cookieValue.push(cookie)
    }
  })

  Cookies.set(COOKIE_NAME, cookieValue, { sameSite: 'strict', expires: 365 })
}

/**
 * Get cookie consent
 */
export function getCookie () {
  const cookie = Cookies.get(COOKIE_NAME)

  if (!cookie) {
    return
  }

  const settings = {}

  cookie.split(',').forEach(cookie => {
    settings[cookie] = true
  })

  return settings
}
